import { render } from "./itemFaq.vue?vue&type=template&id=3527d580"
import script from "./itemFaq.vue?vue&type=script&lang=js"
export * from "./itemFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__